<template>
  <v-card class="mt-0 flex d-flex flex-column" outlined :loading="loading">
    <v-card-title class="justify-center">
      Billed Revenue (MTD)

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
        </template>
        <span
          >Total amount that has been billed so far this month. This total will
          include activity that happened last month, but was billed this
          month.</span
        >
      </v-tooltip>
    </v-card-title>
    <v-card-text>
      <v-simple-table>
        <tbody>
          <tr>
            <td>Premium Calls</td>
            <td>{{ callTotal | dollarsCents }}</td>
          </tr>
          <tr>
            <td>Premium Clicks</td>
            <td>{{ clickTotal | dollarsCents }}</td>
          </tr>
          <tr>
            <td>Monthly Upgrade Fees</td>
            <td>{{ subscriptionTotal | dollarsCents }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { startOfTomorrow, startOfMonth } from "date-fns";
import { getBillingRevenueGraph } from "../../api/report";

export default {
  name: "BilledRevenue",

  data() {
    return {
      loading: false,
      clickTotal: 0,
      callTotal: 0,
      helplineTotal: 0,
      subscriptionTotal: 0
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData(
      startDate = startOfMonth(new Date()),
      endDate = startOfTomorrow()
    ) {
      try {
        this.loading = true;

        const result = await getBillingRevenueGraph(startDate, endDate);
        if (result.items.length == 2) {
          console.error("too many results", result.items);
        } else if (result.items.length == 1) {
          this.clickTotal = result.items[0].clicks;
          this.callTotal = result.items[0].calls;
          this.subscriptionTotal = result.items[0].subscriptions;
        }
      } catch (e) {
        console.error("ERROR IN BILLED REVENUE", e);
      }

      this.loading = false;
    }
  }
};
</script>
